import { render, staticRenderFns } from "./ParticaWebsiteBase.vue?vue&type=template&id=1fe067f7&"
import script from "./ParticaWebsiteBase.vue?vue&type=script&lang=ts&"
export * from "./ParticaWebsiteBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports